import {
  Box,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  chakra,
} from "@chakra-ui/react";
import { Button, ToolbarHeader } from "shared";

type ModalOrderNotesProps = {
  isOpen: boolean;
  onClose: () => void;
  notes: string | undefined;
};

function ModalOrderNotes({ isOpen, onClose, notes }: ModalOrderNotesProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="gray.200" borderRadius="0.875rem">
        <ModalHeader>
          <ToolbarHeader
            titleText={
              <chakra.span fontSize="1.0625rem" fontWeight="600">
                Order Notes
              </chakra.span>
            }
            rightButtons={[<Button onClick={onClose}>Close</Button>]}
          />
        </ModalHeader>
        <ModalBody p="1rem">
          <Box
            borderRadius="0.75rem"
            bg="white"
            border="1px solid"
            borderColor="gray.450"
            p="0.75rem"
          >
            <Text>{notes}</Text>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export { ModalOrderNotes };
